import axios from '../plugins/axios'

export default {
    create({ plan_id, stripe_token, coupon_code }){
      return axios.post('/api/v1/subscriptions/create', {
        plan_id: plan_id,
        stripe_token: stripe_token,
        coupon_code: coupon_code,
      })
    },
    update({ plan_id, coupon_code}){
      return axios.post('/api/v1/subscriptions/update', {
        plan_id: plan_id,
        coupon_code: coupon_code,
      })
    },
    destroy(){
      return axios.post('/api/v1/subscriptions/destroy')
    },
    check_invoice_status(){
      return axios.post('/api/v1/subscriptions/invoice/status')
    },
    check_coupon_exists({ coupon_code, plan_id }){
      return axios.post('/api/v1/subscriptions/check_coupon', {
        coupon_code: coupon_code,
        plan_id: plan_id,
      })
    },
}
